import * as actionType from '../action-type';

const initialState = {
  data: {},
};

const hardwoodDetailedReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.UPDATE_HARDWOOD_DETAILED_REPORT:
      return {
        ...state,
        data: { ...state.data, ...action.payload },
      };
    case actionType.RESET_HARDWOOD_DETAILED_REPORT:
      return initialState;
    default:
      return state;
  }
};

export default hardwoodDetailedReportReducer;